import { useEffect, useState } from 'react';
import axios from '../../api/axiosInstance';
import Loader from './components/Loader';
import ErrorBox from './components/ErrorBox';

export default function Inbox() {
  const search = new URLSearchParams(window.location.search);
  const businessId = search.get('business_id');

  const [threads, setThreads] = useState([]);
  const [state, setState] = useState('loading');

  useEffect(() => {
    setState('loading');
    axios
      .get('/dashboard/inbox', { params: { business_id: businessId } })
      .then(({ data }) => {
        setThreads(data);
        setState('ready');
      })
      .catch(() => setState('error'));
  }, [businessId]);

  if (state === 'loading') return <Loader />;
  if (state === 'error') return <ErrorBox message="Failed to load inbox." />;

  return (
    <div className="mx-auto max-w-5xl p-6">
      <h1 className="mb-4 text-xl font-semibold">Inbox</h1>

      {threads.length === 0 ? (
        <p className="text-gray-600">No messages yet.</p>
      ) : (
        <ul className="divide-y divide-gray-200">
          {threads.map((th) => (
            <li key={th.id} className="py-4">
              <p className="font-medium">{th.subject}</p>
              <p className="text-sm text-gray-500">{th.preview}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
